import Reactotron from "reactotron-react-js"
export const Tron = Reactotron